export default __webpack_public_path__ + "static/media/pycharm.b8c60677.svg";